import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const StorageStatusService = {
    status: async () => axios.get(API_KEEPER + "/storageUsage").catch((err) => { throw err }),

    attaches: async () => axios.get(API_KEEPER + "/storageUsage/attaches").then(({data}) => data).catch((err) => { throw err }),

    archiver: async (archiver) => axios.get(API_KEEPER + "/storageUsage/timeline/archiver/" + archiver).catch((err) => { throw err }),

    allArchiver: async () => axios.get(API_KEEPER + "/storageUsage/timeline/allarchivers").catch((err) => { throw err }),
};

export default StorageStatusService;